// Touch screens: the browser's Back (Android's edge-swipe gesture, Safari's edge swipe, the Back button) does
// not leave the game in the middle of a deal (owner 2026-10-23: dragging a card of the first column started
// Android's Back gesture). One extra history entry is kept on top of the page; Back takes that entry and the
// game stays. The entry is pushed when a touch ends (Chrome skips entries added without a user gesture when
// going back, and for a touch only its end counts as one), and again right after a Back. A web page cannot
// hold Back completely: in Chrome a second Back in a row, with no touch between, still leaves the page.
let armed = false;

export function installBackGuard() {
  if (navigator.maxTouchPoints <= 0) return; // a mouse has its own Back button and expects it to work
  const arm = (e: PointerEvent) => {
    if (armed || e.pointerType === 'mouse') return; // a touch laptop's mouse keeps its plain Back
    armed = true;
    history.pushState({ poBackGuard: true }, '', location.href);
  };
  document.addEventListener('pointerup', arm, { capture: true, passive: true });
  window.addEventListener('popstate', () => {
    armed = !!(history.state as { poBackGuard?: boolean } | null)?.poBackGuard;
    // the guard was taken: put it back at once (browsers that keep an entry pushed without a gesture hold the
    // next Back too; Chrome skips such an entry, so the next touch pushes a fresh one)
    if (!armed) {
      armed = true;
      history.pushState({ poBackGuard: true }, '', location.href);
    }
  });
}
